export default __webpack_public_path__ + "static/media/icons.a940d584.woff";